import {useEffect, useState} from 'react'
import {currentMirror} from './config'

const textsArr = ['main']

export type textType = {
  main: {
    siteName: string
    supportMail: string
    canadaAddress: string
    estoniaAddress: string
    ukAddress: string
    gibraltarAddress: string
  }
}

export const text: textType = {
  main: {
    siteName: '',
    supportMail: '',
    canadaAddress: '',
    estoniaAddress: '',
    ukAddress: '',
    gibraltarAddress: ''
  }
}

export function useTextLoad(): boolean {
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    (async () => {
      for (const key of textsArr) {
      // @ts-ignore
        text[key] = (await import(`shared/mirrors/${currentMirror}/text/${key}`))[key]
      }
    })()

    setIsLoad(true)
  }, [])

  return isLoad
}